module.exports = __webpack_public_path__ + "img/noContent.f29c9efe.png";